import { render, staticRenderFns } from "./EmailBasicEditor.vue?vue&type=template&id=59cd7a8f"
import script from "./EmailBasicEditor.vue?vue&type=script&lang=js"
export * from "./EmailBasicEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports